module.exports = __webpack_public_path__ + "static/media/recycle-grey.687052e2.png";